export default __webpack_public_path__ + "static/media/zingPcv2@2x.f7aa0016.png";